import RachelIcon from '@components/v2/icons/Rachel';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import LangEnum from '../../../../../../lang/LangEnum';
import { AddOrderProductTestIds } from '../../../../../../utils/testIds/OrderProducts.testIds';
import { useIsRachelAvailable } from '../../../../../rachel/hooks/useIsRachelAvailable';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { useAskRachelAboutModes } from './hooks/useAskRachelAboutModes';

interface AskRachelAboutModesButtonProps {
  onAsk: () => void;
}

const AskRachelAboutModesButtonInner = ({ onAsk }: AskRachelAboutModesButtonProps) => {
  const { translate } = useTranslation();
  const { ask } = useAskRachelAboutModes();

  const label = translate(LangEnum.ADD_ORDER_PRODUCTS_MODE_RACHEL_LABEL);

  const handleClick = () => {
    onAsk();
    ask();
  };

  return (
    <Tooltip TooltipContent={label} placement="top">
      <IconButton
        icon={RachelIcon}
        size="small"
        color="secondary"
        testId={AddOrderProductTestIds.MODE_MENU_RACHEL}
        ariaLabel={label}
        onClick={handleClick}
      />
    </Tooltip>
  );
};

const AskRachelAboutModesButton = (props: AskRachelAboutModesButtonProps) => {
  const isRachelAvailable = useIsRachelAvailable();

  if (!isRachelAvailable) {
    return null;
  }

  return <AskRachelAboutModesButtonInner {...props} />;
};

export default AskRachelAboutModesButton;
